var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "custom-table__action" },
    [
      _c("mds-button", {
        attrs: {
          size: "small",
          variation: "icon-only",
          icon: "ellipsis-circle",
          type: "button",
          id: _vm.rowName,
        },
        nativeOn: {
          click: function ($event) {
            return _vm.handleClick.apply(null, arguments)
          },
        },
      }),
      _vm._v(" "),
      _c(
        "mds-popover",
        {
          staticClass: "custom-table__popover",
          attrs: {
            size: "small",
            "triggered-by": _vm.rowName,
            position: ["bottom-left"],
          },
          model: {
            value: _vm.toggle,
            callback: function ($$v) {
              _vm.toggle = $$v
            },
            expression: "toggle",
          },
        },
        [
          _c(
            "mds-list-group",
            { staticClass: "custom-table__list" },
            [
              _c("mds-list-group-item", {
                staticClass: "custom-table__option",
                attrs: { text: "Edit" },
                nativeOn: {
                  click: function ($event) {
                    return _vm.triggerEvent("edit")
                  },
                },
              }),
              _vm._v(" "),
              _c("mds-list-group-item", {
                staticClass: "custom-table__option",
                attrs: { text: "Delete" },
                nativeOn: {
                  click: function ($event) {
                    return _vm.triggerEvent("delete")
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }